import styled from "styled-components";


export const FormContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
`;


export const Title = styled.h2`
  font-size: 26px;
  margin-bottom: 5px;
  color: #008394;
`;

export const Subtitle = styled.p`
  margin-bottom: 20px;
  color: #555;
`;

export const StyledForm = styled.form`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const StyledFormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${props => props.fullWidth && `
    grid-column: 1 / -1;
  `}
`;

export const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #333;
`;

export const StyledInput = styled.input`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  &:focus {
    outline: none;
    border-color: #008394;
  }
`;

export const StyledTextarea = styled.textarea`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  &:focus {
    outline: none;
    border-color: #008394;
  }
`;

export const StyledSelect = styled.select`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
  &:focus {
    outline: none;
    border-color: #008394;
  }
`;

export const SubmitButton = styled.button`
  grid-column: 1 / -1;
  justify-self: center;
  align-items: center;
  padding: 12px 24px;
  background-color: #008394;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  &:hover {
    background-color: #EEA746;
  }
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }

  span {
    margin-left: 8px;
  }
`;